<template>
    <div>
        <div v-if="selectedSgaCompleto.clasePeligro == ''"
             class="tex"
        >
            <h5>{{ clasificacionSGAListas.sinSGA }} </h5>
        </div>
        <b-row class="mb-2">
            <b-col md="4">
                <label>Idioma</label>
                <el-select v-model="idioma.seleccionado"
                           placeholder="Idioma"
                           size="small"
                           @change="actualizarSgaCompleto"
                >
                    <el-option v-for="i in idiomas"
                               :key="i"
                               :label="i"
                               :value="i"
                    />
                </el-select>
            </b-col>
        </b-row>

        <!-- PICTOGRAMAS -->
        <b-row>
            <b-col>
                <div class="titulo-sga-completo">
                    <span v-if="idioma.seleccionado === 'Espanol'">Pictogramas</span>
                    <span v-else-if="idioma.seleccionado === 'Ingles'">Pictograms</span>
                    <span v-else-if="idioma.seleccionado === 'Portugues'">Pictogramas</span>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col v-if="pictogramas.homologacion && typeof pictogramas.homologacion === 'object' && pictogramas.homologacion.length"
                   class="text-center"
            >
                <b-img v-for="(pictograma, index) in pictogramas.homologacion"
                       :key="index"
                       :src="pictograma.direccion"
                       thumbnail
                       fluid
                       style="max-width: 100px; height:100px; border: 1px solid #ccc;"
                       class="m-2"
                />
            </b-col>
            <b-col v-else
                   class="text-center p-2"
            >
                <div v-if="selectedSgaCompleto.clasificacionPictograma == 'NA'">
                    <span v-if="idioma.seleccionado === 'Espanol'">NO APLICA</span>
                    <span v-else-if="idioma.seleccionado === 'Ingles'">DOES NOT APPLY</span>
                    <span v-else-if="idioma.seleccionado === 'Portugues'">NO APLICA</span>
                </div>
                <div v-else>
                    <span v-if="idioma.seleccionado === 'Espanol'">SIN PICTOGRAMA</span>
                    <span v-else-if="idioma.seleccionado === 'Ingles'">WITHOUT PICTOGRAM</span>
                    <span v-else-if="idioma.seleccionado === 'Portugues'">SIN PICTOGRAM</span>
                </div>
            </b-col>
        </b-row>

        <!-- CLASE DE PELIGRO -->
        <b-row>
            <b-col>
                <div class="titulo-sga-completo">
                    <span v-if="idioma.seleccionado === 'Espanol'">Clase de peligro</span>
                    <span v-else-if="idioma.seleccionado === 'Ingles'">Hazard Class</span>
                    <span v-else-if="idioma.seleccionado === 'Portugues'">Classe de Perigo</span>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <p v-html="selectedSgaCompleto.clasePeligro"></p>
            </b-col>
        </b-row>

        <!-- PALABRA DE ADVERTENCIA -->
        <b-row>
            <b-col>
                <div class="titulo-sga-completo">
                    <span v-if="idioma.seleccionado === 'Espanol'">Palabra de advertencia</span>
                    <span v-else-if="idioma.seleccionado === 'Ingles'">Signal Word</span>
                    <span v-else-if="idioma.seleccionado === 'Portugues'">Palavra-sinal</span>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <div class="p-2 font-weight-bold"
                     v-html="selectedSgaCompleto.palabraSga"
                />
            </b-col>
        </b-row>

        <!-- INDICACIONES DE PELIGRO -->
        <b-row>
            <b-col>
                <div class="titulo-sga-completo">
                    <span v-if="idioma.seleccionado === 'Espanol'">Indicaciones de peligro</span>
                    <span v-else-if="idioma.seleccionado === 'Ingles'">Hazard Statement</span>
                    <span v-else-if="idioma.seleccionado === 'Portugues'">Declarações de Perigo</span>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <p class="pt-2 pl-2 pr-2 m-0"
                   v-html="selectedSgaCompleto.indicaciones"
                />
            </b-col>
        </b-row>

        <!-- GENERALES -->
        <b-row>
            <b-col>
                <div class="titulo-sga-completo">
                    <span v-if="idioma.seleccionado === 'Espanol'">Generales</span>
                    <span v-else-if="idioma.seleccionado === 'Ingles'">Generals</span>
                    <span v-else-if="idioma.seleccionado === 'Portugues'">Generalidades</span>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <ul v-if="idioma.seleccionado === 'Espanol'"
                    class="list-unstyled m-2"
                >
                    <li>
                        <span class="font-weight-bold">P101</span> Si se necesita consejo médico, tener a mano el envase o la
                                                                   etiqueta.
                    </li>
                    <li>
                        <span class="font-weight-bold">P102</span> Mantener fuera del alcance de los niños.
                    </li>
                    <li>
                        <span class="font-weight-bold">P103</span> Leer la etiqueta antes del uso.
                    </li>
                </ul>

                <ul v-else-if="idioma.seleccionado === 'Ingles'"
                    class="list-unstyled mb-0"
                >
                    <li>
                        <span class="font-weight-bold">P101</span> If medical advice is needed, have the container or label at
                                                                   hand.
                    </li>
                    <li>
                        <span class="font-weight-bold">P102</span> Keep out of the reach of children.
                    </li>
                    <li>
                        <span class="font-weight-bold">P103</span> Read the label before use.
                    </li>
                </ul>

                <ul v-else-if="idioma.seleccionado === 'Portugues'"
                    class="list-unstyled mb-0"
                >
                    <li>
                        <span class="font-weight-bold">P101</span> Se for necessário aconselhamento médico, tenha o recipiente ou
                                                                   o rótulo à mão.
                    </li>
                    <li>
                        <span class="font-weight-bold">P102</span> Mantenha fora do alcance de crianças.
                    </li>
                    <li>
                        <span class="font-weight-bold">P103</span> Leia o rótulo antes de usar.
                    </li>
                </ul>
            </b-col>
        </b-row>

        <!-- PREVENCIÓN -->
        <b-row>
            <b-col>
                <div class="titulo-sga-completo">
                    <span v-if="idioma.seleccionado === 'Espanol'">Prevención</span>
                    <span v-else-if="idioma.seleccionado === 'Ingles'">Prevention</span>
                    <span v-else-if="idioma.seleccionado === 'Portugues'">Prevenção</span>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <p class="pt-2 pl-2 pr-2 m-0"
                   v-html="selectedSgaCompleto.prevencion"
                />
            </b-col>
        </b-row>

        <!-- INTERVENCIÓN -->
        <b-row>
            <b-col>
                <div class="titulo-sga-completo">
                    <span v-if="idioma.seleccionado === 'Espanol'">Intervención</span>
                    <span v-else-if="idioma.seleccionado === 'Ingles'">Intervention</span>
                    <span v-else-if="idioma.seleccionado === 'Portugues'">Intervenção</span>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <p class="pt-2 pl-2 pr-2 m-0"
                   v-html="selectedSgaCompleto.intervencion"
                />
            </b-col>
        </b-row>

        <!-- ALMACENAMIENTO -->
        <b-row>
            <b-col>
                <div class="titulo-sga-completo">
                    <span v-if="idioma.seleccionado === 'Espanol'">Almacenamiento</span>
                    <span v-else-if="idioma.seleccionado === 'Ingles'">Storage</span>
                    <span v-else-if="idioma.seleccionado === 'Portugues'">Armazenagem</span>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <p class="pt-2 pl-2 pr-2 m-0"
                   v-html="selectedSgaCompleto.almacenamiento"
                />
            </b-col>
        </b-row>

        <!-- ELIMINACIÓN -->
        <b-row>
            <b-col>
                <div class="titulo-sga-completo">
                    <span v-if="idioma.seleccionado === 'Espanol'">Eliminación</span>
                    <span v-else-if="idioma.seleccionado === 'Ingles'">Disposal</span>
                    <span v-else-if="idioma.seleccionado === 'Portugues'">Eliminação</span>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <p class="pt-2 pl-2 pr-2 m-0"
                   v-html="selectedSgaCompleto.eliminacion"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';

export default {
    name: 'SgaCompleto',
    props: ['admin'],
    computed: {
        ...mapState('sgacompleto', ['selectedSgaCompleto', 'version', 'idioma', 'clasificacionSGAListas']),
        ...mapState('etiquetas', ['VisualEmpresa']),
        ...mapState('sga', ['idiomas', 'versiones', 'pictogramas', 'conPictograma']),
        ...mapState("productos", ["selectedProduct"]),
    },
    async mounted() {
        let productId = this.$route.params.id;
        if(productId === undefined){
            productId = this.selectedProduct.id;
        }
        await this.getSgaCompleto(productId);
        await this.getPictogramas(productId);
        await this.getClasificacionSGAListas();
    },
    methods: {
        async actualizarSgaCompleto() {
            await this.getSgaCompleto(this.$route.params.id);
            await this.getClasificacionSGAListas();
        },
        ...mapActions('sgacompleto', ['getSgaCompleto', 'getClasificacionSGAListas']),
        ...mapMutations('sgacompleto', ['cambiaIdioma', 'cambiaVersion']),
        ...mapActions('sga', ['getPictogramas']),
    }
};
</script>
<style>
@media screen and (max-width: 570px) {
    .actualizar-sga {
        margin-left: 0 !important;
    }

    .actualizar-sga .col-sm-6 {
        display: flex;
    }
}

@media screen and (min-width: 570px) {
    .pictogramas-homologacion {
        height: 140px;
    }
}

.titulo-sga-completo {
    background: #ff0018;
    color: #fff;
    padding: 8px;
    vertical-align: middle;
    border-radius: 6px;
    font-size: 18px;
    font-weight: bold;
}
</style>
